//#region Util Imports

import * as $ from 'jquery'

//#endregion

import { DataProvider } from '../../helpers/data-provider';
import { Enums } from '../common/enums';
import { IJsonSerializable, IOpChangeState, IReferenceType } from '../util/interfaces';
import { OpDescr } from './op-descr';
import { TypeHelper, LocalizationHelper } from '../../helpers';

export class OpActionType implements IReferenceType, IOpChangeState, IJsonSerializable {
    // #region Fields
    public idActionType: number
    public name: string
    public idDescr: number
    public isActionDataFixed: boolean
    public descr: OpDescr
    // #endregion

    // #region Custom properties
    public referenceType: Enums.ReferenceType
    public referenceValue: any
    // #endregion

    constructor(opObj: any) {
        this.fromJSON(opObj)
    }

    // #region IOpChangeState implementation
    public opState: Enums.OpChangeState
    // #endregion
    
    // #region IReferenceType implementation
    public getReferenceType(): Enums.ReferenceType {
        return Enums.ReferenceType.ActionType
    }
    public getReferenceKey(): number {
        return this.idActionType
    }
    public getReferenceValue(): any {
        return this
    }
    // #endregion

    public fromJSON(opObj: any, compressed: boolean = false): void {
        if (opObj) {
            if (compressed || (opObj && opObj.__IC && opObj.__IC == 1)) {
                this.idActionType = opObj.IT
                this.name = opObj.N
                this.idDescr = opObj.I
                this.isActionDataFixed = opObj.IDF
                this.descr = opObj.D ? new OpDescr(opObj.D) : null
                this.opState = opObj.O
            } else {
                this.idActionType = opObj.ID_ACTION_TYPE
                this.name = opObj.NAME
                this.idDescr = opObj.ID_DESCR
                this.isActionDataFixed = opObj.IS_ACTION_DATA_FIXED
                this.descr = opObj._Descr ? new OpDescr(opObj._Descr) : null
                this.opState = opObj.OpState
                this.referenceType = opObj.ReferenceType
                this.referenceValue = opObj.ReferenceValue
            }
        }
    }

    public toJSON(compressed: boolean = false): any {
        if (compressed) {
            return {
                IT: this.idActionType,
                N: this.name,
                I: this.idDescr,
                IDF: this.isActionDataFixed,
                D: this.descr ? this.descr.toJSON(compressed) : null,
                O: this.opState,
                __IC: 1
            }
        } else {
            return {
                ID_ACTION_TYPE: this.idActionType,
                NAME: this.name,
                ID_DESCR: this.idDescr,
                IS_ACTION_DATA_FIXED: this.isActionDataFixed,
                _Descr: this.descr ? this.descr.toJSON(compressed) : null,
                OpState: this.opState,
                ReferenceType: this.referenceType,
                ReferenceValue: this.referenceValue
            }
        }
    }

    public toString(): string {
        let displayString: string

        if (this.descr) {
            displayString = this.descr.description
        } else {
            displayString = this.name
        }

        if (TypeHelper.isNullOrEmpty(displayString)) {
            displayString = ""
        }

        if (this.referenceType != null && this.referenceValue != null) {
            let targetString: string = ''

            switch (this.referenceType) {
                case Enums.ReferenceType.IdLocation: {
                    targetString = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Location)
                    break;
                }
                case Enums.ReferenceType.IdMeter: {
                    targetString = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Meter)
                    break;
                }
                case Enums.ReferenceType.SerialNbr: {
                    targetString = LocalizationHelper.getLocalizedText(LocalizationHelper.Text.Device)
                    break;
                }
            }

            if (!TypeHelper.isNullOrEmpty(targetString)) {
                displayString = `${targetString}: ${displayString}`
            }
        }

        return displayString
    }

    public static loadNavigationProperties(dataProvider: DataProvider, list: OpActionType[]): JQueryPromise<OpActionType[]> {
        const defered: JQueryDeferred<OpActionType[]> = $.Deferred<OpActionType[]>()

        defered.resolve(list)

        return defered.promise()
    }
}